<header *ngIf="!user.isStudent" class="d-print-none">
  <div id="primaryNavigationBar" class="row gx-0 portal-navbar">
    <div class="col">
      <nav #navMenu id="navigation-menu" class="navbar navbar-toggleable navbar-expand navbar-inverse background-pattern br-primary"
           data-cy="header-navbar">
        <div id="headerLeft" #headerLeft>
          <a href="#" class="link-logo" rel="icon" (click)="goHome($event)">
            <img class="logo-image" [src]='brandLogoData?.src' [alt]="brandLogoData?.altTranslationKey | translate">
          </a>

          <!-- HAMBURGER TOGGLE (mobile only) -->
          <button
            #menuToggle
            class="hamburger-menu-toggle"
            [attr.aria-expanded]="isMenuOpen"
            aria-controls="hamburger-nav-menu"
            aria-label="Main Menu"
            type="button"
            id="hamburger-menu"
            (click)="toggleMenu()"
          >
            <span class="hamburger-bar"></span>
            <span class="hamburger-bar"></span>
            <span class="hamburger-bar"></span>
          </button>

          <!-- HAMBURGER DROPDOWN MENU (mobile only) -->
          <ul
            id="hamburger-nav-menu"
            class="hamburger-nav-menu"
            [hidden]="!isMenuOpen"
            role="menu"
          >
            <li role="none" class="hamburger-user-info">
              <span class="hamburger-user-name">{{ userNameSchoolId }}</span>
            </li>

            <li role="none" class="hamburger-divider"></li>

            <li role="none">
              <a role="menuitem" class="hamburger-nav-item" routerLink="/account" (click)="turnMenuOff()">
                {{ 'myAccountLink' | translate }}
              </a>
            </li>

            <li role="none" *ngIf="canSelfAssignLicenses">
              <a role="menuitem" class="hamburger-nav-item" [routerLink]="teacherLicensesRoute" (click)="turnMenuOff()">
                Licenses
              </a>
            </li>

            <li role="none">
              <a class="hamburger-nav-item"
                role="menuitem"
                ariaCurrentWhenActive="page"
                id="chooseLanguageLink"
                routerLink="/account/language"
                routerLinkActive="active"
                *ngIf="user.isParent">
                {{ 'chooseLanguageLink' | translate }}
              </a>
            </li>

            <li role="none">
              <a *ngIf="user.roles.length > 1"
                role="menuitem"
                href="#"
                id="chooseAreaMenuLink"
                class="hamburger-nav-item"
                (click)="chooseRoleClick($event)">
                {{ 'header-chooseRole' | translate }}
              </a>
            </li>

            <li role="none">
              <a
                *ngIf="isMasqueraded"
                role="menuitem"
                class="hamburger-nav-item"
                id="stopMasqueradingLink"
                [title]="'Stop masquerading as ' + userNameSchoolId"
                (click)="verifyStopMasquerade()">
                Stop Masquerading
              </a>
            </li>

            <li role="none">
              <a role="menuitem" class="hamburger-nav-item" routerLink="/logout" (click)="turnMenuOff()">
                {{ 'logoutLink' | translate }}
              </a>
            </li>
          </ul>
        </div>

        <div class="collapse navbar-collapse" id="navbarNavDropdown">
          <div class="navbar-nav d-flex w-100">
            <div role="menubar" class="navbar-left">
              <div #primaryHeaderMenu *ngFor="let menu of primaryMenuItems">
                <!-- DROPDOWN MENU ITEM -->
                  <button
                    *ngIf="!menu.isRouted && !menu.noInteraction"
                    role="menuitem"
                    data-bs-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                    data-bs-auto-close="outside"
                    class="nav-item nav-link defaultTransition dropdown-toggle routed-menu-item"
                    id="{{menu.id}}MenuLink"
                    (click)="primaryMenuItemClicked($event, primaryHeaderMenu)"
                  >
                  @if (menu.iconClass) {
                    <i class="pe-2 fa {{ menu.iconClass }}" aria-hidden="true"></i>
                  }
                    {{ menu.label }}
                  </button>
                <div
                  #navigationDropdownMenu
                  role="menu"
                  class="dropdown-menu dropdown-menu-right dropdown-menu-container navigation-dropdown"
                  id="{{menu.id}}MenuDropdownContainer"
                  [class.help-dropdown-container]="menu.id === helpMenuId"
                  tabindex="-1"
                  (focusout)="onDropdownFocusOut($event, primaryHeaderMenu, navigationDropdownMenu)"
                >
                  <!-- ADMIN MANAGE DROPDOWN (district admin or single school school admin) -->
                  <ng-container *ngIf="isSingleAdmin(menu)">
                    <a
                      *ngFor="let adminManageOption of dropdownMenuItems"
                      role="menuitem"
                      class="dropdown-item defaultTransition no-submenu"
                      [id]="adminManageOption.id+'ManageMenuLink'"
                      [class.disabled]="adminManageOption.disabled"
                      [ngbTooltip]="adminManageOption.tooltip"
                      href="#"
                      (click)="handleManageNavigation($event, adminManageOption, primaryHeaderMenu, navigationDropdownMenu)"
                    >{{ adminManageOption.label }}
                    </a>
                  </ng-container>

                  <!-- ADMIN MANAGE DROPDOWN (multiple schools school admin) -->

                  <ng-container *ngIf="isMultiAdmin(menu)">
                    <ul class="list-unstyled">

                    <li *ngFor="let school of headerService.schools">
                      <button
                        tabindex="0"
                        data-bs-auto-close="outside"
                        class="dropdown-item defaultTransition has-submenu dropdown-btn"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                        #schoolDropdownItem
                        [id]="school.educationalUnitId+'MenuLink'"
                        (keydown)="expandSubmenu($event, primaryHeaderMenu, schoolDropdownItem, true)"
                        (click)="expandSubmenu($event, primaryHeaderMenu, schoolDropdownItem, true)">{{ school.name }}
                        <span class="sr-only">, {{ 'header-hasSubmenu' | translate }}</span>
                      </button>

                      <!-- SCHOOL SUBMENU -->
                      <div role="menu" class="dropdown-menu dropdown-submenu school-submenu">
                        <div class="background-pattern-container background-pattern">
                          <a
                            *ngFor="let adminManageOption of headerService.adminSubMenus[school.educationalUnitId]"
                            role="menuitem"
                            class="dropdown-item defaultTransition"
                            href="#"
                            tabindex="0"
                            [id]="school.educationalUnitId+adminManageOption.id+'ManageMenuLink'"
                            [class.disabled]="adminManageOption.disabled"
                            [ngbTooltip]="adminManageOption.tooltip"
                            (keydown)="handleManageNavigation($event, adminManageOption, primaryHeaderMenu, navigationDropdownMenu)"
                            (click)="handleManageNavigation($event, adminManageOption, primaryHeaderMenu, navigationDropdownMenu)"
                          >{{ adminManageOption.label }}
                          </a>
                        </div>
                      </div>
                        </li>
                    </ul>
                  </ng-container>

                  <!-- TEACHER PRODUCT DROPDOWN -->
                  <ng-container *ngIf="menu.id === teacherProductsMenuId">
                    <!-- No products available if Teacher cannot self-assign and doesn't have licenses assigned. -->
                    <p
                      *ngIf="!(headerService.currentMenuTeacherProducts?.length > 0) && !headerService.showProductAssignLicensesButton"
                      class="dropdown-item non-interactive-dropdown-item">
                      No Products Available
                    </p>
                    <ul class="list-unstyled">
                      <li>
                        <!-- Link to Self-Assign licenses page if Teacher can self-assign and doesn't have licenses assigned. -->
                        <a *ngIf="headerService.showProductAssignLicensesButton && headerService.currentMenuTeacherProducts?.length < 1"
                          role="menuitem"
                          id="licensesMenuLink"
                          class="dropdown-item defaultTransition"
                          [routerLink]="teacherLicensesRoute"
                          routerLinkActive="active"
                          ariaCurrentWhenActive="page"
                          data-cy="licenses-link"
                          (click)="licensesClicked(secondaryHeaderMenu, dropdownItem)">
                          Licenses
                        </a>
                      </li>
                      <li *ngFor="let product of headerService.currentMenuTeacherProducts">
                        <button
                          tabindex="0"
                          data-bs-auto-close="outside"
                          class="dropdown-item defaultTransition has-submenu dropdown-btn"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                          #productDropdownItem
                          [id]="product.productLineKey+'LicensesMenuLink'"
                          (keydown)="expandSubmenu($event, primaryHeaderMenu, productDropdownItem, true)"
                          (click)="expandSubmenu($event, primaryHeaderMenu, productDropdownItem, true)">{{ product.name }}
                          <span class="sr-only">, {{ 'header-hasSubmenu' | translate }}</span>
                        </button>
                        <!-- PRODUCT VARIANT SUBMENU -->
                        <div role="menu" class="dropdown-menu dropdown-submenu products-submenu">
                          <div class="background-pattern-container background-pattern">
                            <a
                              *ngFor="let variant of product.variants"
                              role="menuitem"
                              [id]="product.productLineKey+variant.variantType+'SubmenuLink'"
                              href="#"
                              class="dropdown-item defaultTransition px-1 py-1"
                              tabindex="0"
                              (keydown)="clickedProductSubMenuItem($event, product, variant, primaryHeaderMenu, navigationDropdownMenu)"
                              (click)="clickedProductSubMenuItem($event, product, variant, primaryHeaderMenu, navigationDropdownMenu)">{{ variant.name }}
                            </a>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </ng-container>

                  <!-- TEACHER CLASSES DROPDOWN -->
                  <ng-container *ngIf="menu.id === teacherClassesMenuId">
                    <div role="menu">
                      <div *ngIf="(headerService.classesMenuItems$ | async )?.length > 0" id="classesList" class="list-group">
                        <div *ngFor="let school of headerService.classesMenuItems$ | async" class="classes-menu-group">
                            <p class="dropdown-group-header">{{school.schoolName}}</p>
                            <a *ngFor="let c of school.classGroupBySchool; index as i"
                              role="menuitem"
                              class="dropdown-item no-submenu group-item"
                              [id]="c.classroomId"
                              routerLinkActive="active"
                              [routerLinkActiveOptions]="{exact: false}"
                              href="#"
                              (click)="handleClassesNavigation($event, c.classroomId, primaryHeaderMenu, navigationDropdownMenu)"
                              [routerLink]="school.classIdToRouteMap[c.classroomId]"
                            >{{ c.name }}</a>
                          </div>
                      </div>
                      <div *ngIf="canCreateClass" class="row newClassButtonWrapper">
                        <zbp-button-component
                          role="menuitem"
                          tabindex="0"
                          id="newClassButton"
                          (click)="newClass(primaryHeaderMenu, navigationDropdownMenu)"
                          (keydown)="newClass(primaryHeaderMenu, navigationDropdownMenu)"
                          label="New class"
                          theme="ghost"
                          [fullWidth]="true"
                          iconName="t_cross"
                          iconSize="font-size"
                        ></zbp-button-component>
                      </div>
                    </div>
                  </ng-container>

                  <!-- PARENT CHILDREN DROPDOWN -->
                  <ng-container *ngIf="menu.id === parentChildrenMenuId && !menu.isRouted">
                    <ul class="list-unstyled">
                      <li *ngFor="let child of headerService.parentMenuChildren">
                        <button
                          tabindex="0"
                          data-bs-auto-close="outside"
                          class="dropdown-item defaultTransition has-submenu dropdown-btn"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                          #parentChildDropdownItem
                          [id]="child.userId + 'StudentMenuLink'"
                          (keydown)="expandSubmenu($event, primaryHeaderMenu, parentChildDropdownItem, true)"
                          (click)="expandSubmenu($event, primaryHeaderMenu, parentChildDropdownItem, true)">
                            {{ child.fullName }}
                            <span class="sr-only">, {{ 'header-hasSubmenu' | translate }}</span>
                        </button>
                        <!-- CLASSROOM SUBMENU -->
                        <div role="menu" class="dropdown-menu dropdown-submenu products-submenu">
                          <div class="background-pattern-container background-pattern">
                            <!-- No Classroom: shown when all of a child's classrooms were filtered out (missing classroomId) -->
                            @if (!child.classrooms?.length) {
                              <a
                                role="menuitem"
                                [id]="child.userId + 'NoClassroomMenuLink'"
                                href="#"
                                class="dropdown-item defaultTransition px-1 py-1"
                                tabindex="0"
                                (keydown)="handleParentNoClassroomNavigation($event, primaryHeaderMenu, navigationDropdownMenu, child.userId)"
                                (click)="handleParentNoClassroomNavigation($event, primaryHeaderMenu, navigationDropdownMenu, child.userId)"
                              >{{ 'header-noClassroom' | translate }}</a>
                            }
                            @for(classroom of child.classrooms; track classroom.classroomId) {
                              <a
                                role="menuitem"
                                [id]="child.userId + classroom.classroomId + 'ClassroomMenuLink'"
                                href="#"
                                class="dropdown-item defaultTransition px-1 py-1"
                                tabindex="0"
                                (keydown)="handleParentClassroomNavigation($event, primaryHeaderMenu, navigationDropdownMenu, child.userId, classroom.classroomId)"
                                (click)="handleParentClassroomNavigation($event, primaryHeaderMenu, navigationDropdownMenu, child.userId, classroom.classroomId)"
                              >{{ classroom.name }}</a>
                              }
                          </div>
                        </div>
                      </li>
                    </ul>
                  </ng-container>

                  <!-- HELP DROPDOWN -->
                  @if (menu.id === helpMenuId) {
                    @for (helpOption of helpDropdownMenuItems; track helpOption.id) {
                      @if (helpOption.isExternal) {
                        <a
                          role="menuitem"
                          class="dropdown-item defaultTransition help-dropdown-item"
                          [id]="helpOption.id + 'HelpMenuLink'"
                          [attr.href]="helpOption.route"
                          target="_blank"
                          rel="noopener noreferrer"
                          [attr.aria-labelledby]="helpOption.id + 'HelpMenuLabel'"
                          (click)="handleHelpDropdownNavigation($event, helpOption, primaryHeaderMenu, navigationDropdownMenu)"
                        >
                          <ng-container *ngTemplateOutlet="helpOptionContent; context: { helpOption: helpOption }"></ng-container>
                          <zbp-icon aria-hidden="true" [iconName]="iconNames.openInNewIcon"></zbp-icon>
                        </a>
                      } @else {
                        <button
                          type="button"
                          role="menuitem"
                          class="dropdown-item defaultTransition help-dropdown-item"
                          [id]="helpOption.id + 'HelpMenuLink'"
                          [attr.aria-labelledby]="helpOption.id + 'HelpMenuLabel'"
                          (click)="handleHelpDropdownNavigation($event, helpOption, primaryHeaderMenu, navigationDropdownMenu)"
                        >
                          <ng-container *ngTemplateOutlet="helpOptionContent; context: { helpOption: helpOption }"></ng-container>
                        </button>
                      }
                    }
                  }
                </div>

                <!-- ROUTED EXTERNAL LINK -->
                 @if(menu.isRouted && menu.isExternal && !menu.noInteraction) {
                  <a
                    role="menuitem"
                    class="nav-item nav-link defaultTransition"
                    id="{{menu.id}}MenuLink"
                    [attr.href]="menu.route"
                    target="_blank">
                    {{ menu.label | translate }}
                  </a>
                 } @else if(menu.isRouted && !menu.isExternal && !menu.noInteraction) {
                  <!-- ROUTED INTERNAL LINK -->
                  <a
                    role="menuitem"
                    class="nav-item nav-link defaultTransition"
                    id="{{menu.id}}MenuLink"
                    [routerLink]="menu.route"
                    [queryParams]="menu.params"
                    [attr.aria-current]="isRouteActive(menu.route) && 'page'"
                    [class.nav-link--student]="user.isStudent"
                    [class.active]="isRouteActive(menu.route)">
                    @if (menu.iconClass) {
                      <i class="pe-2 fa {{ menu.iconClass }}" aria-hidden="true"></i>
                    }

                    {{ menu.label }}
                  </a>
                } @else if (menu.noInteraction) {
                  <!-- TEXT ONLY - NO USER INTERACTION -->
                  <p
                    class="nav-item nav-link defaultTransition nav-no-interaction"
                    id="{{menu.id}}MenuLink"
                    [class.nav-link--student]="user.isStudent">
                    @if (menu.iconClass) {
                      <i class="pe-2 fa {{ menu.iconClass }}" aria-hidden="true"></i>
                    }
                    {{ menu.label }}
                  </p>
                }
              </div>
              @if (!isMasqueraded && !this.isHighlightsPortalUser && (user.isTeacher || user.isDistrictAdmin || user.isSchoolAdmin)) {
                <zbp-button-component id="feedback-button"
                                      theme="reversePrimary"
                                      label="Feedback"
                                      ariaLabel="Feedback"
                                      [iconName]="zbpIconNames.megaphoneIcon"
                                      iconPosition="left"
                                      (clickHandler)="openFeedbackForm()"
                ></zbp-button-component>
              }
            </div>
            <div role="menubar" class="navbar-right">
              <!-- MASQUERADING INDICATOR -->
              @if (isMasqueraded) {
                <ng-container>
                  <zbp-button-component
                    internalId="stopMasqueradingButton"
                    class="nav-item"
                    theme="icon-white"
                    [iconName]="iconNames.mask"
                    [title]="'Stop masquerading as ' + userNameSchoolId"
                    [ariaLabel]="'Stop masquerading as ' + userNameSchoolId"
                    (click)="verifyStopMasquerade()" >
                  </zbp-button-component>
              </ng-container>
              }
              <!-- USER DROPDOWN MENU -->
              <div #secondaryHeaderMenu class="nav-item dropdown ms-auto user-menu-container">
                <button
                  role="menuitem"
                  id="userMenuLink"
                  class="nav-link dropdown-toggle defaultTransition mobile-hidden"
                  data-bs-toggle="dropdown"
                  data-bs-auto-close="outside"
                  aria-haspopup="true"
                  aria-expanded="false"
                  [attr.aria-label]="'User Menu for ' + userNameSchoolId"
                  data-cy="user-menu">
                  <i class="fa fa-user currentUserNameIcon"></i>
                  <span id="currentUser"
                        class="currentUserName"
                  >{{ userNameSchoolId }}</span>
                </button>
                <div #dropdownItem role="menu" id="userMenuDropdown"
                  class="dropdown-menu user-menu-dropdown dropdown-menu-right w-100"
                >
                  <a
                    role="menuitem"
                    id="myAccountMenuLink"
                    class="dropdown-item defaultTransition"
                    routerLink="/account"
                    routerLinkActive="active"
                    ariaCurrentWhenActive="page"
                    [routerLinkActiveOptions]="{exact: true}"
                    data-cy="account-link">
                    {{ 'myAccountLink' | translate }}
                  </a>
                 <a *ngIf="canSelfAssignLicenses"
                    role="menuitem"
                    id="licensesMenuLink"
                    class="dropdown-item defaultTransition"
                    [routerLink]="teacherLicensesRoute"
                    routerLinkActive="active"
                    ariaCurrentWhenActive="page"
                    data-cy="licenses-link"
                    (click)="licensesClicked(secondaryHeaderMenu, dropdownItem)">
                    Licenses
                  </a>
                  <a class="dropdown-item defaultTransition mobile-hidden"
                    role="menuitem"
                    ariaCurrentWhenActive="page"
                    id="chooseLanguageLink"
                    routerLink="/account/language"
                    [routerLinkActiveOptions]="{exact: true}"
                    routerLinkActive="active"
                    *ngIf="user.isParent">
                    {{ 'chooseLanguageLink' | translate }}
                  </a>
                  <a *ngIf="user.roles.length > 1"
                    role="menuitem"
                    id="chooseAreaMenuLink"
                    href="#"
                    class="dropdown-item defaultTransition mobile-hidden"
                    (click)="chooseRoleClick($event)">
                    {{ 'header-chooseRole' | translate }}
                  </a>
                  <a
                    *ngIf="isMasqueraded"
                    role="menuitem"
                    class="dropdown-item defaultTransition mobile-hidden"
                    id="stopMasqueradingLink"
                    [title]="'Stop masquerading as ' + userNameSchoolId"
                    (click)="verifyStopMasquerade()">Stop Masquerading</a>
                  <div class="dropdown-divider"></div>
                  <a id="logOutMenuLink"
                    role="menuitem"
                    class="dropdown-item"
                    routerLink="/logout"
                    routerLinkActive="active"
                    data-cy="logout-link">
                    {{ 'logoutLink' | translate }}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </nav>
    </div>
  </div>
  <zbp-subnavigation id="subnavigationBar" *ngIf="(headerService.showSubnav())"></zbp-subnavigation>
</header>

<!-- HELP DROPDOWN OPTION CONTENT -->
<ng-template #helpOptionContent let-helpOption="helpOption">
  <span class="help-dropdown-icon" aria-hidden="true">
    <zbp-icon [iconName]="helpOption.zbpIconName"></zbp-icon>
  </span>
  <span class="help-dropdown-text">
    <span class="help-dropdown-label" [id]="helpOption.id + 'HelpMenuLabel'">
      {{ helpOption.label }}
      @if (helpOption.isExternal) {
        <span class="sr-only"> (opens in a new tab)</span>
      }
    </span>
    <span class="help-dropdown-description" [id]="helpOption.id + 'HelpMenuDescription'">
      {{ helpOption.description }}
    </span>
  </span>
</ng-template>
